<template>
  <div class="recommend-search-container">
    <div class="search-wrapper">
      <form class="search-input flex-start" action="javascript:void 0">
        <span class="iconfont iconsearch"/>
        <input v-model="payload.keyword" type="text" @keyup.13="searchByName" placeholder="搜索职位或公司" ref="inputText" growing-track='true'>
        <div @click="toBack">取消</div>
      </form>
      <div class="conditions-tab flex">
        <div class="conditions-item flex-center" :class="{'conditions-active': payload.city_names !== '全国'}"
             @click="changeCurrentId(1)">
          <span>{{ payload.city_names }}</span>
          <span class="iconfont" :class="currentId === 1 ? 'iconchevron-up' : 'iconchevron-down'"/>
        </div>
        <div class="conditions-item flex-center" :class="{'conditions-active': companyCount}"
             @click="changeCurrentId(2)">
          <span>公司</span>
          <span class="iconfont" :class="currentId === 2 ? 'iconchevron-up' : 'iconchevron-down'"/>
        </div>
        <div class="conditions-item flex-center" :class="{'conditions-active': requireCount}"
             @click="changeCurrentId(3)">
          <span>要求</span>
          <span class="iconfont" :class="currentId === 3 ? 'iconchevron-up' : 'iconchevron-down'"/>
        </div>
      </div>
      <div class="conditions-content" v-show="currentId">
        <div class="flex conditions-item-content" v-show="currentId === 1">
          <cube-scroll :data="[currentId]">
            <div class="letter-container">
              <template v-for="(letter, index) in letterAry">
                <div :key="index" @click="changeKey(letter)" class="letter flex-center" v-if="letter"
                     :class="{'letter-active': currentLetter === letter.code}">{{letter.name}}
                </div>
              </template>
            </div>
          </cube-scroll>
          <div class="city-container">
            <cube-scroll :data="[currentLetter]">
              <div class="city-content">
                <div class="city flex-center" :class="{'city-active': city.city_name === payload.city_names}"
                     @click="selectCity(city)"
                     v-for="city in cityAry[currentLetter]" :key="city.id">
                  {{city.city_name}}
                </div>
              </div>
            </cube-scroll>
          </div>
        </div>
        <div class="conditions-item-content company-conditions" v-show="currentId === 2">
          <cube-scroll :data="[currentId]">
            <div class="condition-item">
              <p class="title">公司规模</p>
              <div class="content">
                <div class="condition flex-center" :class="{'condition-active': item.name === payload.company_scale }"
                     v-for="(item, index) in conditions.scales" :key="index"
                     @click="selectCondition(item, 'company_scale')">{{ item.name }}
                </div>
              </div>
            </div>
            <div class="condition-item">
              <p class="title">公司类型</p>
              <div class="content">
                <div class="condition flex-center" :class="{'condition-active': item.name === payload.company_nature }"
                     v-for="(item, index) in conditions.nature" :key="index"
                     @click="selectCondition(item, 'company_nature')">{{ item.name }}
                </div>
              </div>
            </div>
            <div class="condition-item">
              <p class="title">行业领域</p>
              <div class="content">
                <div class="condition flex-center"
                     :class="{ 'condition-active': item.name === payload.company_industry }"
                     v-for="(item, index) in conditions.industries" :key="index"
                     @click="selectCondition(item, 'company_industry')">{{ item.name }}
                </div>
              </div>
            </div>
          </cube-scroll>
        </div>
        <div class="conditions-item-content company-conditions" v-show="currentId === 3">
          <cube-scroll :data="[currentId]">
            <div class="condition-item">
              <p class="title">薪资要求</p>
              <div class="content">
                <div class="condition flex-center" :class="{ 'condition-active': item.code === payload.salary }"
                     v-for="(item, index) in conditions.salaries" :key="index" @click="selectCondition(item, 'salary')">
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="condition-item">
              <p class="title">学历要求</p>
              <div class="content">
                <div class="condition flex-center" :class="{ 'condition-active': item.name === payload.degree_name }"
                     v-for="(item, index) in conditions.degrees" :key="index"
                     @click="selectCondition(item, 'degree_name')">{{ item.name }}
                </div>
              </div>
            </div>
            <div class="condition-item">
              <p class="title">经验要求</p>
              <div class="content">
                <div class="condition flex-center" :class="{ 'condition-active': item.name === payload.experience }"
                     v-for="(item, index) in conditions.experiences" :key="index" @click="selectCondition(item, 'experience')">{{ item.name }}
                </div>
              </div>
            </div>
          </cube-scroll>
        </div>
        <div class="screening-sure" v-if="currentId !== 1">
          <button @click="reset">重置</button>
          <button @click="determine">确定{{currentId === 2 && companyCount ? `（${companyCount}）` :
            currentId === 3 && requireCount ? `（${requireCount}）` :
            ''}}
          </button>
        </div>
      </div>
    </div>
    <div class="job-list-container" :class="{'no-result-container': noResultShow}">
      <cube-scroll :data="jobListData" :options="options" @pulling-up="onPullingUp" ref="scroll">
        <company-card v-if="companyData" :data="companyData"/>
        <job-list :list-data="jobListData"></job-list>
        <w-more-loading v-show="moreLoadingShow"></w-more-loading>
        <w-no-more v-show="isEnd"></w-no-more>
      </cube-scroll>
    </div>
    <w-no-result v-show="noResultShow" text="暂无搜索结果"></w-no-result>
    <div class="conditions-mask" v-show="currentId" @click="hideFilterBox"></div>
  </div>
</template>

<script>
	import { nature, industries, degrees, scales, salaries, experiences } from '../../assets/json/conditions'
	import jobList from '../job-components/job-list'
	import WMoreLoading from '../../components/global/w-more-loading'
	import WNoMore from '../../components/global/w-no-more'
	import WNoResult from '../../components/global/w-no-result'
  import CompanyCard from "./companyCard"
	export default {
		name: 'recommend-search',
		data () {
			return {
				keyword: '',
				currentId: '',
				letterAry: [],
				cityAry: [],
				currentLetter: 'hot_cities',
				currentCityName: '全国',
				payload: {
					salary: '',
					company_industry: '不限',
					keyword: '',
					city_names: '全国',
					company_scale: '不限',
					company_nature: '不限',
					degree_name: '不限',
					experience: '不限'
				},
				jobListData: [],
				totalCount: 0,
				options: {
					pullUpLoad: true
				},
				'from': 0,
				noResultShow: false,
        companyData: null
			}
		},
		beforeRouteEnter (to, from, next) {
			next(vm => {
				vm.refreshPageData(from.name)
			})
		},
		async mounted () {
			await this._getCitiesData()
			this.searchByQuery()
      console.log(this.conditions,"====》conditions")
		},
		computed: {
			conditions () {
				return {
					nature: JSON.parse(JSON.stringify(nature)),
					industries: JSON.parse(JSON.stringify(industries)),
					degrees: JSON.parse(JSON.stringify(degrees)),
					scales: JSON.parse(JSON.stringify(scales)),
					salaries: JSON.parse(JSON.stringify(salaries)),
					experiences: JSON.parse(JSON.stringify(experiences)),
				}
			},
			requireCount () {
				let count = 0
				let fields = [ 'salary', 'experience', 'degree_name' ]
				fields.forEach(item => {
					if (this.payload[item] !== '不限' && this.payload[item]) count += 1
				})
				return count
			},
			companyCount () {
				let count = 0
				let fields = [ 'company_scale', 'company_nature', 'company_industry' ]
				fields.forEach(item => {
					if (this.payload[item] !== '不限') count += 1
				})
				return count
			},
			moreLoadingShow () {
				return this.jobListData.length < this.totalCount
			},
			isEnd () {
				return this.jobListData.length && this.jobListData.length === this.totalCount
			}
		},
		watch: {},
		components: {
			jobList,
			WMoreLoading,
			WNoMore,
			WNoResult,
      CompanyCard
		},
		methods: {
		  // 点击mask遮罩收起筛选框
      hideFilterBox() {
        this.currentId = 0
      },
			refreshPageData (name) {
				if (name !== 'recommend-detail') {
					this['from'] = 0
					this.payload = {
						salary: '',
						company_industry: '不限',
						keyword: '',
						city_names: '全国',
						company_scale: '不限',
						company_nature: '不限',
						degree_name: '不限',
						experience: '不限'
					}
					this.jobListData = []
				}
			},
			// 重置
			reset () {
				if (this.currentId === 2) {
					this.payload.company_scale = '不限'
					this.payload.company_nature = '不限'
					this.payload.company_industry = '不限'
				} else if (this.currentId === 3) {
					this.payload.salary = ''
					this.payload.degree_name = '不限'
				}
			},
			// 筛选弹窗中的确定按钮
			determine () {
				this.searchList('search')
				this.currentId = 0
			},
			// 返回方法
			toBack () {
				window.location.href = '/jobs/recommend'
			},
			// 选择 条件
			selectCondition (item, field) {
				if (field === 'salary') {
					this.payload[field] = item.code
				} else {
					this.payload[field] = item.name
				}
			},
			// 选中城市
			selectCity (item) {
				this.currentCityName = item.city_name
				this.payload.city_names = item.city_name
				// this.cityAry.map(i => {
				// 	i.part_cities.forEach(val => {
				// 		val.active = val.adcode === item.adcode
				// 	})
				// })
				this.currentId = 0
				this.searchList('search')
			},
			// 切换城市key
			changeKey (key) {
				this.currentLetter = key.code
			},
			// 切换筛选条件tab
			changeCurrentId (id) {
				if (id === this.currentId) {
					this.currentId = ''
				} else {
					this.currentId = id
				}
			},
			// 获取城市接口
			async _getCitiesData () {
				let res = await this.$api.HrApi.getObtainCity({
					nums: 0,
					job_count: 10
				})
				console.log(res, 'res=====')
				let letterAry = [], cityAry = []
				if (res.code === 1000) {
					for (let key in res.data) {
						if (res.data[key] && res.data[key].length) {
							key === 'hot_cities' ?
								letterAry.push({ code: 'hot_cities', name: '热门城市' }) :
								letterAry.push({ code: key, name: key })
						}
					}
					this.letterAry = letterAry
					res.data.hot_cities.unshift({ city_name: '全国', id: '', active: true })
          this.cityAry = res.data
				}
				// let res = await this.$api.jobs.toObtainCity()
				// this.letterAry = res.data.cities.map(city => city.group_name)
				// this.letterAry.unshift('热门城市')
				// res.data.hot_cities.unshift({ city_name: '全国', id: '', active: true })
				// res.data.cities.unshift({ part_cities: res.data.hot_cities })
				// this.cityAry = res.data.cities
			},
			// 通过query参数查询列表
			async searchByQuery () {
				let { query } = this.$route
				this.payload = {
					...this.payload,
					...query
				}
				if (query && Object.keys(query).length) this.searchList('search')
			},
			// 输入关键字点击enter
			async searchByName () {
				this['from'] = 0
        try{
          let company = await this.$api.staticApi.getSearchCompany({company_name: this.payload.keyword})
          if(company.code === 1000 && company.data.result && JSON.stringify(company.data.result) !== "{}"){
            let res = await this.$api.staticApi.getCompanyDetail(company.data.result.token)
            let res1 = await this.$api.staticApi.getCompanyNum({company_tokens: company.data.result.token})
            if(res.code === 1000){
              this.companyData = {...res.data, ...res1.data.jobs_count[0]}
            }
          }else {
            this.companyData = null
          }
        }catch (e) {
          console.log(e)
        }
				this.searchList('search', 'enterSearch')
        // this.searchList('search')
			},
      // 解析query
      filterQuery(data){
        // console.log('fliter',data);
        this.payload.parsed_query = data
        this.payload.degree_name = !data.degree[0] ? "不限" : data.degree[0]
        // this.payload.job_nature = !data.job_nature[0] ? "不限" : data.job_nature[0]
        this.payload.city_names = !data.location[0] ? "全国" : data.location[0]
        this.payload.company_nature = !data.company_nature[0] ? "不限" : data.company_nature[0]
        // 工作年限
        if (Object.keys(data.work_year).length > 0) {
          let work_years = this.conditions.experiences.find(item => {
            if (!item.code) return false
            let low = item.code.split(',')[0]
            let heigh = item.code.split(',')[1]
            if( data.work_year.lower_bound >= low && !heigh) return true
            return data.work_year.lower_bound >= low && data.work_year.upper_bound <= heigh
          })
          this.payload.experience = !work_years ? "不限" : work_years.name
        } else {
          this.payload.experience = "不限"
        }
        // 单独判断应届生
        if (data.profession_identity[0] === "应届") {
          this.payload.experience = "应届生"
        }
        // 薪资
        if (Object.keys(data.salary).length > 0) {
          let salary = this.conditions.salaries.find(item => {
            if (!item.code) return false
            let low = item.code.split(',')[0]
            let heigh = item.code.split(',')[1]
            if( data.salary.lower_bound >= low && !heigh) return true
            return data.salary.lower_bound >= low && data.salary.upper_bound <= heigh
          })
          this.payload.salary = !salary ? "" : salary.code
        } else {
          this.payload.salary = ""
        }
        // 公司规模
        if (Object.keys(data.company_scale).length > 0) {
          let scale = this.conditions.scales.find(item => {
            if (!item.code) return false
            let low = item.code.split(',')[0]
            let heigh = item.code.split(',')[1]
            if( data.company_scale.lower_bound >= low && !heigh) return true
            return data.company_scale.lower_bound >= low && data.company_scale.upper_bound <= heigh
          })
          this.payload.company_scale = !scale ? "不限" : scale.name
        } else {
          this.payload.company_scale = "不限"
        }
      },
			// 获取搜索列表数据
			async searchList (search, type="") {
				this.noResultShow = false
				let payload = JSON.parse(JSON.stringify(this.payload))
        // 把1年以内 改成 1年以下 搜索
        if (payload.experience === '1年以内') {
          payload.experience = '1年以下'
        }
				for (let key in payload) {
					if (payload[key] === '不限' || payload[key] === '全国' || !payload[key]) payload[key] = ''
				}
        if(!!type){
          let query = await this.$api.HrApi.querySearch({query: payload.keyword})
          if (query.code === 1000) {
            this.filterQuery(query.data.parsed_query)
          }
        }
				let res = await this.$api.HrApi.getJobListByQuerySearch({
					'from': this['from'],
					size: 10,
					...payload
				})
				if (res.code === 1000) {
					this.jobListData = search ? res.data.jobs : [ ...this.jobListData, ...res.data.jobs ]
					if (search) this.$refs.scroll.scrollTo(0, 0)
					if (search && !res.data.jobs.length && res.data.total === 0) this.noResultShow = true
          if(res.data.jobs.length === 0 && res.data.total !== 0){
            this.totalCount = 0
          }else{
            this.totalCount = res.data.total
          }

				}
			},
			onPullingUp () {
				if (!this.isEnd && this.jobListData.length) {
					this['from'] += 10
					this.searchList()
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .recommend-search-container {
    height: $screen-height;
    padding-top: 84px;
    background-color: #f8f8fa;
    .search-wrapper {
      position: fixed;
      top: 0;
      z-index: 10;
      background-color: $color-light;
      .search-input {
        padding: 0 16px;
        width: 100vw;
        height: 44px;
        font-size: $font-size-medium-x;
        .iconsearch {
          position: absolute;
          left: 30px;
          font-weight: bold;
          color: $color-light-gray;
        }
        input {
          width: 85%;
          height: 32px;
          border-radius: 16px;
          color: #9c9c9c;
          background-color: #f9f9f9;
          margin-right: 11px;
          padding-left: 35px;
          font-size: $font-size-medium;
          border: none !important;
        }
        div {
          flex: 1;
          height: 16px;
          font-size: $font-size-medium;
          color: #9c9c9c;
        }
      }
      .conditions-tab {
        width: 100vw;
        height: 40px;
        .conditions-item {
          flex: 1;
          color: $color-title;
          span:first-child {
            margin-right: 8px;
          }
          .iconfont {
            font-weight: bold;
          }
        }
        .conditions-active {
          color: $color-theme;
        }
      }
      .conditions-content {
        height: 446px;
        position: relative;
        .conditions-item-content {
          height: 100%;
          .letter-container {
            .letter {
              width: 100px;
              height: 50px;
              font-size: $font-size-medium;
              color: $color-light-gray;
              text-align: center;
              line-height: 50px;
              background-color: #f8f8fa;
            }
            .letter-active {
              background-color: $color-light;
              color: $color-title;
            }
          }
          .city-container {
            flex: 1;
            .city-content {
              display: flex;
              flex-wrap: wrap;
              background-color: $color-light;
              padding: 16px 0 16px 16px;
              .city {
                height: 30px;
                padding: 0 16px;
                border: 1px solid #ececec;
                color: $color-light-gray;
                border-radius: 2px;
                font-size: $font-size-medium;
                margin-right: 6px;
                margin-bottom: 16px;
                box-sizing: border-box;
              }
              .city-active {
                border: 1px solid $color-theme;
                color: $color-theme;
              }
            }
          }
        }
        .company-conditions {
          padding: 25px 16px 52px;
          .condition-item {
            margin-bottom: 24px;
            .title {
              color: $color-title;
              font-size: $font-size-medium;
              margin-bottom: 16px;
            }
            .content {
              display: flex;
              flex-wrap: wrap;
              .condition {
                padding: 0 16px;
                height: 30px;
                color: $color-light-gray;
                font-size: $font-size-medium;
                border: 1px solid #ececec;
                border-radius: 2px;
                margin-right: 6px;
                margin-bottom: 12px;
              }
              .condition-active {
                color: $color-theme;
                border: 1px solid $color-theme;
              }
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
        .screening-sure {
          position: absolute;
          bottom: 0;
          width: 100vw;
          display: flex;
          height: 52px;
          button {
            width: 50%;
            font-size: $font-size-medium;
            color: $color-light;
            background-color: $color-theme;
            padding: 0;
            margin: 0;
            border: none;
            outline: none;
            &:first-child {
              background-color: $color-light;
              color: $color-title;
              border-top: 1px solid #f9f9f9;
            }
          }
        }
      }
    }
    .job-list-container {
      height: calc(calc(var(--vh, 1vh) * 100) - 84px);
      /deep/ .recommend-item {
        padding: 20px 24px;
        margin-bottom: 6px;
        /*&:first-child {*/
        /*  margin-top: 6px;*/
        /*}*/
      }
    }
    .no-result-container {
      background-color: $color-light;
    }
    .conditions-mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba($color: #000000, $alpha: 0.3);
      z-index: 5;
    }
  }
</style>
